import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var types = {
  button: 'button',
  submit: 'submit',
  reset: 'reset'
};
export var typesArray = Object.values(types);
export var roundThemes = {
  b2b: 'b2b',
  b2c: 'b2c',
  warning: 'warning',
  secondary: 'secondary',
  secondaryWhite: 'secondaryWhite',
  destructive: 'destructive'
};
export var roundThemesArray = Object.values(roundThemes);
export var themes = _objectSpread(_objectSpread({}, roundThemes), {}, {
  blue: 'blue',
  outline: 'outline',
  outlineWhite: 'outlineWhite',
  white: 'white',
  basic: 'basic',
  b2cGradient: 'b2cGradient',
  b2bGradient: 'b2bGradient'
});
export var themesArray = Object.values(themes);
export var sizes = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'x-large'
};
export var sizesArray = Object.values(sizes);
export var colors = {
  neutral: 'N900',
  b2b: 'T600',
  b2c: 'G600',
  b600: 'B600',
  o600: 'O600'
};
export var colorsArray = Object.values(colors);